import { Card } from '@ellucian/react-design-system/core';
import { withStyles } from '@ellucian/react-design-system/core/styles';
import classnames from 'classnames';
import React = require('react');
import { IRule } from './models/Rule';

const styles = () => ({

});

export interface ICardInternalProps {
    lineId: string;
    idPrefixRule: string;
    ruleIndex: string;
    classes: any;
    isSelected: boolean;
    isEditing: boolean;
    readOnly: boolean;
    onUnselectRule: (rule: IRule) => void;
    rule: (rule: IRule) => void;
    onSelectRule: (rule: IRule) => void;
    children: any;
    selectAttributeMode?: boolean;
}

export class CardInternal extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
    }

    public render() {
        const {
            lineId,
            idPrefixRule,
            ruleIndex,
            classes,
            isSelected,
            isEditing,
            readOnly,
            onUnselectRule,
            rule,
            onSelectRule,
            children,
            selectAttributeMode
        } = this.props;
        return (
            <React.Fragment>
                {!selectAttributeMode &&
                    <Card
                        data-line-id={lineId}
                        id={`${idPrefixRule}_ruleCard_${ruleIndex}`}
                        className={classnames(classes.rulePaper, {
                            [classes.rulePaperSelected]: isSelected,
                            [classes.rulePaperReadOnly]: !isEditing,
                        })}
                        onClick={(e) => {
                            if (readOnly || isEditing) {
                                return;
                            }
                            // ignore buttons clicks
                            if (e.target.type === 'button' || e.target.tagName === 'svg' || e.target.tagName === 'LI') {
                                return;
                            }
                            if (isSelected && onUnselectRule) {
                                onUnselectRule(rule);
                            } else if (!isSelected && onSelectRule) {
                                onSelectRule(rule);
                            }
                        }}
                        spacingOptions={{spacing: 'none'}}
                    >

                        {children}

                    </Card>
                }
                {selectAttributeMode &&
                    children
                }

            </React.Fragment>
        );
    }
}
export const QueryRuleHeader = [
    withStyles(styles),
].reduce((memo, hoc: (it: any) => any) => hoc(memo), CardInternal);
